import styled from '@emotion/styled';
import { theme } from '@arnold/common';

export const Pill = styled.span`
  width: ${theme.spacing.f};
  height: ${theme.spacing.f};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.body.small.regular.fontSize};
  background-color: ${theme.colors.actionPrimary.default};
  color: ${theme.colors.textInverted.primary};
  line-height: ${theme.spacing.f};
  letter-spacing: normal;
`;

export const StickyFilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${theme.spacing.f};
  cursor: pointer;
  user-select: none;
`;

export const FilterLabel = styled.span`
  color: ${theme.colors.actionPrimary.default};
  font-weight: 500;
  margin-right: 8px;
  margin-left: 4px;
  line-height: 16px;
`;

export const FilterSectionLabel = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.text.secondary};
`;

export const CategoryFilterButton = styled.button<{ $isSelected: boolean }>`
  padding: 6px 8px;
  border-radius: ${theme.borderRadius.l};
  font-size: ${theme.typography.body.small.button.fontSize};
  letter-spacing: 0.035rem;
  font-weight: ${theme.typography.body.small.button.fontWeight};
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? theme.colors.actionPrimary.active : theme.colors.borderMain.default)};
  background-color: ${({ $isSelected }) => ($isSelected ? theme.colors.actionPrimary.active : 'transparent')};
  box-shadow: ${({ $isSelected }) => ($isSelected ? theme.shadows.elevationContentBlockOutstanding : 'none')};
  color: ${({ $isSelected }) => ($isSelected ? '#fff' : theme.colors.text.primary)};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  margin-right: 6px;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: ${theme.colors.backgroundBasic.disabled};
    border-color: ${theme.colors.borderMain.default};
    color: ${theme.colors.text.disabled};
    box-shadow: none;
  }
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  margin-bottom: 12px;
`;

export const SearchAndSortContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StickyFilterContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
`;

export const StickyFilterContent = styled.div`
  margin-left: 260px;
  width: 100%;
  max-width: 928px;
  max-height: 90vh;
  overflow-y: auto;
  background-color: ${theme.colors.backgroundCover?.default || '#fff'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
